import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/images/logo.png';

const EntityNamePage = () => {
  const [entityName, setEntityName] = useState('');

  const handleClear = () => {
    setEntityName('');
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <img
          src={logo}
          alt="Tillionx"
          style={styles.logo}
        />

        <h2 style={styles.title}>Enter your entity name</h2>    

        <label style={styles.label}>Entity name</label>
        <div style={styles.inputWrapper}>
          <input
            type="text"
            value={entityName}
            onChange={(e) => setEntityName(e.target.value)}
            placeholder=""
            style={styles.input}
          />
          {entityName && (
            <button onClick={handleClear} style={styles.clearBtn}>
              ✕
            </button>
          )}
        </div>

        <button style={styles.nextBtn}>Next</button>

        <div style={styles.footer}>
          <Link to="/signup" style={styles.linkYellow}>Sign up as an individual</Link>
          <span style={{ margin: '0 5px' }}>or</span>
          <Link to="/login" style={styles.link}>Log in</Link>
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: {
    backgroundColor: '#f9f9f9',
    minHeight: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: "0px 10px",
  },
  card: {
    width: 450,
    backgroundColor: '#fff',
    borderRadius: 20,
    padding: 30,
    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
    textAlign: 'center',
  },
  logo: {
    width: 120,
    marginBottom: 20,
  },
  title: {
    fontSize: 24,
    fontWeight: '600',
    marginBottom: 30,
  },
  label: {
    textAlign: 'left',
    display: 'block',
    fontSize: 14,
    fontWeight: 500,
    marginBottom: 5,
  },
  inputWrapper: {
    position: 'relative',
    marginBottom: 20,
  },
  input: {
    width: '96%',
    padding: '12px 0px 12px 12px',
    borderRadius: 8,
    border: '1px solid #fcd535',
    fontSize: 14,
    outline: 'none',
  },
  clearBtn: {
    position: 'absolute',
    right: 10,
    top: '50%',
    transform: 'translateY(-50%)',
    background: 'transparent',
    border: 'none',
    fontSize: 16,
    cursor: 'pointer',
    color: '#999',
  },
  nextBtn: {
    width: '100%',
    backgroundColor: '#fcd535',
    color: '#000',
    padding: 12,
    border: 'none',
    borderRadius: 8,
    fontWeight: '600',
    cursor: 'pointer',
    marginBottom: 25,
  },
  footer: {
    fontSize: 14,
    marginTop: 10,
    color: '#666',
  },
  link: {
    color: '#1e70bf',
    textDecoration: 'none',
    fontWeight: 500,
  },
  linkYellow: {
    color: '#f0b90b',
    textDecoration: 'none',
    fontWeight: 500,
  },
};

export default EntityNamePage;
